<template>
  <div class="staker-unstake">
    
    <div class="title">
      Stake ETH
    </div>
    <!-- <div v-if="warn" class="warn">
      System is waiting for matching validators 
    </div> -->
    <div class="inputs-amount" :class="{'inputs-warn': warn}">
      <input type="text" placeholder="ETH AMOUNT" v-model.trim="ethAmount"  @keyup="checkAmountInput" />
      <div class="icon">
        <img src="../assets/eth.png" />
      </div>
    </div>
    <div class="desc">
      <template v-if="!isPoolWaiting">
        <template v-if="totalStakedAmount <= 0">
          {{ totalStakedAmount }} ETH is staked in pool contracts.
        </template>
        <template v-else>
          {{ totalStakedAmount }} ETH is staked in <span class="pool" @click="jumpToPool">pool</span> contracts.
        </template>
      </template>
      <template v-else>
        {{ waitingStaked }} ETH is waiting to be staked in the <span class="pool" @click="jumpToPool">pool</span>
      </template>
    </div>
    <div class="eth-items">
      <div class="eth-apr">
        <div class="item">
          <div class="item-title">
            Estimated APR
          </div>
          <div class="item-value">
            {{ apr }}
          </div>
        </div>

        <!-- <div class="item-joiner">
          +
        </div>

        <div class="item">
          <div class="item-title">
            Dropped FIS
          </div>
          <div class="item-value item-value-fis">
            3%
          </div>
        </div> -->
      </div>

      <div class="item">
        <div class="item-title">
          You will get rETH
        </div>
        <div class="item-value">
          {{ returnRETH }}
        </div>
      </div>
    </div>
    <div class="stake-btn" :class="{'btn-active': stakeBtnActiveStatus == 1}" @click="stake">
      Stake
    </div>

  </div>
</template>

<script>
import { setTimeout } from 'timers';
import { Toast } from 'mint-ui';
import { Indicator } from 'mint-ui';
import NumberUtil from '../util/numberUtil.js';
import Web3Util from '../util/web3Util.js';
import Rpc from '../util/rpc.js';

const stakeBtnActive = 1;
const stakeBtnInActive = 0;

export default {
  name: 'stakerUnstaked',
  data() {
    let lang = window.localStorage.getItem('lang');
    return {
      lang: lang,
      ethBalance: 0,
      ethAmount: '',
      warn: false,
      isPoolWaiting: true,
      totalStakedAmount: '0.000000',
      waitingStaked: '--',
      minimumDeposit: '',
      ratio: '',
      returnRETH: '--',
      stakeBtnActiveStatus: stakeBtnInActive,
      clickStake: false,
      currentAddress: '',
      apr: '--'
    }
  },
  methods: {

    jumpToPool() {
      this.$router.push({ name: 'ethpool', params: {source: 'stakerUnstaked'}});
    },

    validateAmount() {
      if (!this.ethAmount || this.ethAmount < 0) {
        this.ethAmount = '';
        this.returnRETH = '--';
        return false;
      }
      if (isNaN(this.ethAmount)) {
        Toast({ 
          message: 'The deposited amount is invalid', 
          duration: 3000 
        });
        this.ethAmount = '';
        this.returnRETH = '--';
        return false;
      }

      if (this.ethAmount < this.minimumDeposit) {
        Toast({ 
          message: 'The deposited amount is less than the minimum deposit size: ' + this.minimumDeposit, 
          duration: 3000 
        });
        this.ethAmount = '';
        this.returnRETH = '--';
        return false;
      }

      return true;
    },

    checkAmountInput() {
      if (this.ethAmount && !isNaN(this.ethAmount) && this.ethAmount >= 0) {
        if (this.ethBalance > 0 && Number(this.ethAmount) >= Number(this.ethBalance)) {
          Toast({ 
            message: 'The input amount exceeds your transferrable balance', 
            duration: 3000 
          });
          this.ethAmount = '';
          this.returnRETH = '--';
          this.stakeBtnActiveStatus = stakeBtnInActive;
          return;
        }

        this.stakeBtnActiveStatus = stakeBtnActive;
        let pointStr = this.ethAmount.toString().split('.')[1];
        if (pointStr) {
          let pointLen = pointStr.length;
          if (pointLen > 6) {
            this.ethAmount = this.ethAmount.substr(0, this.ethAmount.length - 1);
          }
        }
       
        if (this.ratio) {
          this.returnRETH = NumberUtil.handleEthGweiToFixed(this.ethAmount / this.ratio);;
        }
      } else {
        Toast({ 
          message: 'The deposited amount is invalid', 
          duration: 3000 
        });
        this.ethAmount = '';
        this.returnRETH = '--';

        this.stakeBtnActiveStatus = stakeBtnInActive;
      }
    },

    stake() {
      if (this.clickStake) {
        return;
      }

      this.clickStake = true;

      if (!this.validateAmount()) {
        this.clickStake = false;
        this.stakeBtnActiveStatus = stakeBtnInActive;
        return;
      }

      if (this.ethAmount <= 0) {
        Toast({ 
          message: 'The amount should be larger than 0', 
          duration: 3000 
        });
        return;
      }

      let web3 = Web3Util.getWeb3();
      let contract = new web3.eth.Contract(Web3Util.getStafiUserDepositAbi(), Web3Util.getStafiUserDepositAddress(), {
        from: this.currentAddress
      });
      const amount = web3.utils.toWei(this.ethAmount.toString());

      Indicator.open('Loading...');

      contract.methods.deposit().send({value: amount}).then(result => {
        Indicator.close();
        this.clickStake = false;

        if (result && result.status) {
          Toast({ 
            message: 'Deposit successfully', 
            duration: 3000 
          });
          setTimeout(() => {
            this.$emit('stakeSuccess');
          }, 3300);
        } else {
          Toast({ 
            message: 'Error! Please try again', 
            duration: 3000 
          });
        }
      })
      .catch((error) => {
        Indicator.close();
        this.clickStake = false;
        Toast({ 
          message: error.message, 
          duration: 3000 
        });
      });

    }
  },

  created() {
    if (ethereum.selectedAddress) {
      this.currentAddress = ethereum.selectedAddress;

      let web3 = Web3Util.getWeb3();

      ethereum.request({ method: 'eth_getBalance', params: [this.currentAddress, 'latest'] }).then(result => {
        this.ethBalance =  web3.utils.fromWei(result, 'ether');
      });

      let userDepositContract = new web3.eth.Contract(Web3Util.getStafiUserDepositAbi(), Web3Util.getStafiUserDepositAddress(), {
        from: this.currentAddress
      });

      userDepositContract.methods.getMinimumDeposit().call().then(result => {
        this.minimumDeposit = web3.utils.fromWei(result, 'ether');
      });

      let rEthContract = new web3.eth.Contract(Web3Util.getRETHTokenAbi(), Web3Util.getRETHTokenAddress(), {
        from: this.currentAddress
      });

      const amount = web3.utils.toWei('1');
      rEthContract.methods.getEthValue(amount).call().then(result => {
        this.ratio = web3.utils.fromWei(result, 'ether');
      });

      let poolQueueContract = new web3.eth.Contract(Web3Util.getStafiStakingPoolQueueAbi(), Web3Util.getStafiStakingPoolQueueAddress(), {
        from: this.currentAddress
      });

      poolQueueContract.methods.getNextCapacity().call().then(nextCapacity => {
        if (nextCapacity > 0) {
          userDepositContract.methods.getBalance().call().then(result => {
            let balance = parseFloat(web3.utils.fromWei(result, 'ether'));
            this.waitingStaked = NumberUtil.handleEthAmountToFixed(balance);
          });
        } else {
          this.isPoolWaiting = false;
           Rpc.fetchStakingPoolStatus({}).then(result => {
            if (result.status == '80000') {
              if (result.data) {
                if (result.data.stakeAmount) {
                  this.totalStakedAmount = NumberUtil.handleEthAmountToFixed(result.data.stakeAmount);
                }
              }
            } 
          });
        }
      });

      Rpc.fetchArp({arpType: 1}).then(result => {
        if (result.status == '80000') {
          if (result.data && result.data.stakerApr) {
            this.apr = result.data.stakerApr + '%';
          }
        } 
      });

    } else {
      this.$router.push('/');
    }
    
  }

  
};
</script>

<style lang="scss">
@import "../mixin.scss";

.staker-unstake {

  .warn {
    margin-top: 20px;
    color: #FD5D89;
  }

  .inputs-amount {
    margin-top: 60px;
    width: 442px;
    height: 50px;
    border-radius: 3.65px;
    border: 1px solid #BFBFBF;
    padding-left: 25px;
    position: relative;
    
    .icon {
      height: 36px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 10px;
      img {
        height: 100%;
      }
    }
    input {
      font-size: 22px;
      font-weight: bold;
      width: 390px;
      height: 48px;
      background-color: #2B3239;
      border: 0;
      color: #fff;

      &:focus {
        outline: none
      }
    }
  }

  .inputs-warn {
    margin-top: 20px;
  }

  .stake-btn {
    cursor: pointer;
    margin-left: 361px;
    width: 110px;
    height: 42px;
    line-height: 42px;
    font-size: 16px;
    color: #23292F;
    font-weight: bold;
    background-color: #00F3AB;
    opacity: 0.4;
    border-radius: 21px;
    text-align: center;
  }

  .btn-active {
    opacity: 1;
  }

  .eth-apr {
    display: flex;

    .item-joiner {
      margin-left: 17px;
      margin-right: 17px;
      margin-top: 16px;
      font-size: 30px;
      font-weight: bold;
    }

    .item-value-fis {
      text-align: center;
    }
  }

  .eth-items {
    margin-top: 60px;
    .item {
      margin-bottom: 32px;

      .item-title {
        font-size: 16px;
      }

      .item-value {
        font-size: 30px;
        color: #00F3AB;
        font-weight: bold;
      }
    }
  }
}
  
</style>